import { IDocumentModel } from '../../../interfaces/ICase';
import classNames from 'classnames';

export function DownloadIconButton(props: {
    isDownloading: boolean;
    isError: boolean;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    document: IDocumentModel;
}) {
    if (props.isDownloading) {
        return (
            <button className="btn btn-no-bg mr-0">
                <i style={{ cursor: 'pointer' }} className="fal fa-spinner fa-solid fa-spin" />
            </button>
        );
    }

    return (
        <button className="btn btn-no-bg mr-0" onClick={props.onClick}>
            <i
                className={classNames('fal fa-lg fa-file-download', props.isError && 'text-danger')}
            />
        </button>
    );
}
